import React, { useState, useEffect } from "react";
import SearchableList from "../../../../SearchableList/UsersSearchList";
import SearchableMappingList from "../../../../SearchableList/SearchableMappingList";

import { FaPlus, FaSave, FaEdit, FaTrash } from "react-icons/fa";
import { getUserInfo } from "../../../../../services/authService-sighup";
import Dialog from "../../../FormDialog/Dialog";
import { USERGROUP_TAB } from "../../../constants/constants";
import DomainDropdown from "../../../../DropDowns/DomainDropdown/DomainDropdown";
import {
  AMP_ENTITLEMENT_DOMAINS,
  collectionDomainsForRole,
} from "../../../constants/entitlementDomains";

interface User {
  loginName:string;
  domain: string;
  userId: string;
}


interface UserGroupFormProps {
  onSaveUserGroup: (newGroup: any) => void;
  // onSaveChanges: (userGroupId: string, updatedGroup: any) => void;
  onSaveChanges: (userGroupId: number, updatedGroup: any) => Promise<void>;
  onClearSelection: () => void;
  selectedUserGroup?: any;
  userGroups: any[];
  onDirtyChange: (dirty: boolean) => void;
  onModeChange: (mode: 'create' | 'edit' | 'view' | null) => void;
  registerTabSwitchGuard?: (guard: () => boolean | Promise<boolean>) => void;
  selectedCollections: string[];
  selectedPogs: string[];
  onCollectionChange: (ids: string[]) => void;
  onPogChange: (ids: string[]) => void;
  onDeleteUserGroup: (roleId: number) => void;
  canDelete?: boolean;
}

const UserGroupForm: React.FC<UserGroupFormProps> = ({
  onSaveUserGroup,
  onSaveChanges,
  onClearSelection,
  selectedUserGroup,
  userGroups,
  onDirtyChange,
  onModeChange,
  registerTabSwitchGuard,
  selectedCollections,
  selectedPogs,
  onCollectionChange,
  onPogChange,
  onDeleteUserGroup,
  canDelete = false,
}) => {
  const [groupName, setGroupName] = useState("");
  const [roleDomain, setRoleDomain] = useState("amp");
  // const []
  const [selectedUsers, setSelectedUsers] = useState<User[]>([]);
  // const [selectedAssetGroup, setSelectedAssetGroup] = useState("");
  const [isViewMode, setIsViewMode] = useState(false);
  const [userGroupId, setUserGroupId] = useState<string | null>(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [user, setUser] = useState<{ fullName: string; email: string } | null>(null);
  const [activeField, setActiveField] = useState<string | null>(null);
  const [modifiedFields, setModifiedFields] = useState<Record<string, boolean>>({});
  const [dialog, setDialog] = useState<{
      open: boolean;
      title: string;
      message: string;
      confirmButtonText: string;
      cancelButtonText?: string;
      onConfirm: () => void;
      onCancel?: () => void;
    }>({
      open: false,
      title: "",
      message: "",
      confirmButtonText: "",
      onConfirm: () => {},
    });
  
    const closeDialog = () => {
      setDialog({
        open: false,
        title: "",
        message: "",
        confirmButtonText: "",
        onConfirm: () => {},
      });
    };

  useEffect(() => {
      const fetchUserInfo = () => {
        const userInfo = getUserInfo();
        if (userInfo) {
          setUser({
            fullName: userInfo.fullName || "Unknown User",
            email: userInfo.email || "",
          });
        }
      };
      fetchUserInfo();
    }, []);
    

  const createdBy = user ? `${user.email || user.fullName}` : "Unknown User";
  const modifiedBy = user ? `${user.email || user.fullName}` : "Unknown User";

  useEffect(() => {
    // if (selectedUserGroup) {
      if (selectedUserGroup && !isEditMode) {
      setUserGroupId(selectedUserGroup.user_group_id || null);
      setGroupName(selectedUserGroup.user_group_name || "");
      setRoleDomain(selectedUserGroup.domain || "amp");
      
      // const userObjects = selectedUserGroup.users?.map((user: any) => ({
      //   loginName: user.login_name,
      //   domain: user.email,
      //   userId: user.user_id,
      // })) || [];
      const userObjects = selectedUserGroup.users?.map((user: any) => ({
        loginName: user.login_name,
        domain: user.email || "",
        userId: String(user.user_id),  // 👈 FORCE STRING
      })) || [];      

      setSelectedUsers(userObjects);
      // setSelectedAssetGroup(selectedUserGroup.asset_group_name || "");
      setIsViewMode(true);
      // setIsEditMode(false);
      onDirtyChange(false);
    // } else {
    } else if (selectedUserGroup && isEditMode) {
      setUserGroupId(selectedUserGroup.user_group_id || null);
      setGroupName(selectedUserGroup.user_group_name || "");
      setRoleDomain(selectedUserGroup.domain || "amp");
      const userObjects = selectedUserGroup.users?.map((user: any) => ({
        loginName: user.login_name,
        domain: user.email,
        userId: user.user_id,
      })) || [];
      setSelectedUsers(userObjects);
      setIsViewMode(true);
      setIsEditMode(false);
    }
  }, [selectedUserGroup]);

 

  const handleSubmit = (e: React.MouseEvent) => {
    e.preventDefault();
    const trimmedName = groupName.trim().toLowerCase();
  
    if (!groupName) {
      setDialog({
        open: true,
        title: USERGROUP_TAB.VALIDATION.MISSING_INFO_GROUP_TITLE,
        message: USERGROUP_TAB.VALIDATION.MISSING_INFO_GROUP_MESSAGE,
        confirmButtonText: "Close",
        onConfirm: closeDialog,
      });
      return;
    }
  
    if (selectedUsers.length === 0) {
      setDialog({
        open: true,
        title: USERGROUP_TAB.VALIDATION.MISSING_INFO_TITLE,
        message: USERGROUP_TAB.VALIDATION.MISSING_INFO_MESSAGE,
        confirmButtonText: "Close",
        onConfirm: closeDialog,
      });
      return;
    }
  
        const nameAlreadyExists = userGroups.some((group) => {
          const isSameName = group.user_group_name.trim().toLowerCase() === trimmedName;
          const isDifferentId = group.user_group_id !== userGroupId;
          return isSameName && isDifferentId;
        });
      
        if (nameAlreadyExists) {
          setDialog({
            open: true,
            title: "Duplicate Role Name",
            message: `A role with the name "${groupName}" already exists. Please choose a different name.`,
            confirmButtonText: "Close",
            onConfirm: closeDialog,
          });
          return;
        }
        
    const userGroupPayload = {
      user_group_name: groupName,
      domain: roleDomain,
      user_ids: selectedUsers.map(user => user.userId),
      description: "",
      enabled: "",
      sys_created_by: createdBy,
      sys_modified_by: modifiedBy,
    };
    const userGroupUpdatePayload = {
      user_group_name: groupName,
      user_ids: selectedUsers.map(user => user.userId),
      description: "",
      enabled: "",
      sys_created_by: createdBy,
      sys_modified_by: modifiedBy,
    };
    // if (isEditMode && userGroupId) {
    //   onSaveChanges(userGroupId, userGroupPayload);
    // } else {
    //   onSaveUserGroup(userGroupPayload);
    //   resetForm();
    // }
    if (isEditMode && userGroupId) {
      setDialog({
        open: true,
        title: USERGROUP_TAB.DIALOGS.CONFIRM_EDIT_TITLE,
        message: USERGROUP_TAB.DIALOGS.CONFIRM_EDIT_MESSAGE,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        onConfirm: () => {
          // onSaveChanges(userGroupId,userGroupUpdatePayload);
          onSaveChanges(Number(userGroupId), userGroupUpdatePayload);
          setModifiedFields({});
          closeDialog();
          resetForm();
          onClearSelection();
          
        },
        onCancel: closeDialog
      });
    } else {
      setDialog({
        open: true,
        title: USERGROUP_TAB.DIALOGS.CONFIRM_CREATE_TITLE,
        message: USERGROUP_TAB.DIALOGS.CONFIRM_CREATE_MESSAGE,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        onConfirm: () => {
          onSaveUserGroup(userGroupPayload);
          closeDialog();
          resetForm();
          onClearSelection();
          
        },
        onCancel: closeDialog
      });
    }
    onDirtyChange(false);
    // onClearSelection();
    // resetForm();
  };
  
  
  const resetForm = () => {
    setGroupName('');
    setRoleDomain("amp");
    // setSelectedAssetGroup('');
    setSelectedUsers([]);
    setIsEditMode(false);
    setIsViewMode(false);
    // onClearSelection(); 
    onDirtyChange(false); 
    onModeChange(null);
    setModifiedFields({});
   
    onCollectionChange([]);
    onPogChange([]);
    
  };

  const resetToSelectedCompany = () => {
    if (selectedUserGroup) {
      setUserGroupId(selectedUserGroup.user_group_id || null);
      setGroupName(selectedUserGroup.user_group_name || "");
      setRoleDomain(selectedUserGroup.domain || "amp");
      const userObjects = selectedUserGroup.users?.map((user: any) => ({
        loginName: user.login_name,
        domain: user.email,
        userId: user.user_id,
      })) || [];
      setSelectedUsers(userObjects);
      setIsEditMode(false);
      setIsViewMode(true);
      onDirtyChange(false);
      onModeChange("view");
      setModifiedFields({});
    }
  };
  
  const handleCancelClick = () => {
    setDialog({
      open: true,
      title: "Cancel Editing?",
      message: "Are you sure you want to discard changes?",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => {
        closeDialog();
        resetToSelectedCompany();
        setModifiedFields({});
      },
      onCancel: closeDialog,
    });
  };
  
    const handleNew = () => {
      setDialog({
        open: true,
        title: USERGROUP_TAB.DIALOGS.CONFIRM_NEW_TITLE,
        message: USERGROUP_TAB.DIALOGS.CONFIRM_NEW_MESSAGE,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        onConfirm: () => {
          setGroupName("");
          setSelectedUsers([]);
          // setSelectedAssetGroup("");

          onCollectionChange([]);
          onPogChange([]);

          setIsViewMode(false);
          setIsEditMode(false);
          resetForm();
          onClearSelection();
          onModeChange('create');
          onDirtyChange(false);
          closeDialog();
           // Ensure selection is cleared
        },
        onCancel: closeDialog,
      });
    };
    

  const handleEdit = () => {
    setIsEditMode(true);
    onDirtyChange(true); 
    setModifiedFields({});
    onModeChange('edit');
  };

  // Without admin the form is view-only: every field stays disabled.
  const fieldsLocked = !canDelete || (!isEditMode && isViewMode);

  const handleDeleteClick = () => {
    if (!userGroupId) return;
  
    setDialog({
      open: true,
      title: "Confirm Delete",
      message: "Are you sure you want to delete this role?",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => {
        onDeleteUserGroup(Number(userGroupId));
        closeDialog();
        resetForm();
      },
      onCancel: closeDialog,
    });
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md font-poppins">
      {dialog.open && (
        <Dialog
          title={dialog.title}
          message={dialog.message}
          confirmButtonText={dialog.confirmButtonText}
          cancelButtonText={dialog.cancelButtonText}
          onConfirm={dialog.onConfirm}
          onCancel={dialog.onCancel}
          onClose={closeDialog}
        />
      )}
<div className="flex justify-between items-center gap-4 mb-4">

<div>
  {isEditMode && canDelete && (
    <button
      onClick={handleDeleteClick}
      type="button"
      className="flex items-center gap-2 px-4 py-2 bg-red-500 text-white font-medium rounded-lg hover:bg-red-600"
    >
      <FaTrash className="w-4 h-4" />
      Delete
    </button>
  )}
</div>

<div className="flex gap-4">  {canDelete && !isViewMode && !isEditMode && (
    <button
      onClick={handleSubmit}
      className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
    >
      <FaPlus className="w-4 h-4" />
      Create
    </button>
  )}

  {canDelete && isViewMode && !isEditMode && (
    <>
      <button
        onClick={handleNew}
        className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
      >
        <FaPlus className="w-4 h-4" />
        New
      </button>

      <button
        onClick={handleEdit}
        className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
      >
        <FaEdit className="w-4 h-4" />
        Edit
      </button>
    </>
  )}

  {canDelete && isEditMode && (
    <>
      <button
        onClick={handleSubmit}
        className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
      >
        <FaSave className="w-4 h-4" />
        Save
      </button>

      <button
        onClick={handleCancelClick}
        className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
      >
        Cancel
      </button>
    </>
  )}
</div>
</div>

      <form className="space-y-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div>
            <label className="block text-gray-700 mb-2 font-medium">Role Name<span className="text-red-500 text-lg align-top ml-1">*</span></label>
            <input
              type="text"
              value={groupName}
              // onChange={(e) => setGroupName(e.target.value)}
              onChange={(e) => {
                setGroupName(e.target.value);
                // onDirtyChange(true); 
                setModifiedFields(prev => ({ ...prev, groupName: true }));
              }}
              placeholder="Enter role name"
              required
              onFocus={() => setActiveField("groupName")}
              disabled={fieldsLocked}
              className={`w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200 ${
                !isEditMode
                  ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                  : isEditMode && (activeField === "groupName"|| modifiedFields.groupName)
                  ? "border-green-500 focus:ring-2 focus:ring-green-500"
                  : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
              }`}
            />
          </div>
          <div>
            <label className="block text-gray-700 mb-2 font-medium">Domain<span className="text-red-500 text-lg align-top ml-1">*</span></label>
            {/* Fixed once the role exists: its mappings are stored under it. */}
            <DomainDropdown
              selectedDomain={roleDomain}
              onDomainChange={(val: string) => {
                setRoleDomain(val);
                // Asset groups are per-domain, so a domain switch clears them.
                onCollectionChange([]);
                setModifiedFields(prev => ({ ...prev, domain: true }));
              }}
              disabled={!canDelete || isEditMode || isViewMode}
              onFocus={() => setActiveField("domain")}
              className={`w-full p-1 border rounded-lg text-sm transition-all duration-200 ${
                !canDelete || isEditMode || isViewMode
                  ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                  : activeField === "domain" || modifiedFields.domain
                  ? "border-green-500 focus:ring-2 focus:ring-green-500"
                  : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
              }`}
            />
          </div>
        </div>

        <div>
          <label className="block text-gray-700 mb-2 font-medium">Users<span className="text-red-500 text-lg align-top ml-1">*</span></label>
          <div className="bg-gray-50  rounded-md border border-gray-300">
            <SearchableList
              selectedItems={selectedUsers}
              onSelectionChange={setSelectedUsers}
              preserveItemOrder={false}
              reorderSelectedOnOutside={true}
              disabled={fieldsLocked}
            />
          </div>
        </div>

        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">

        {/* -------- COLLECTIONS -------- */}
        <div>
          <label className="block text-gray-700 mb-2 font-medium">
            Asset Groups (Collections)
          </label>

          <div className="bg-gray-50 rounded-md border border-gray-300">
            <SearchableMappingList
              fetchUrl={`${process.env.REACT_APP_ENTITLEMENTS_API}/collection?enabled_only=false`}
              selectedIds={selectedCollections}
              onSelectionChange={onCollectionChange}
              idField="collection_id"
              nameField="collection_name"
              allowedDomains={collectionDomainsForRole(roleDomain)}
              preserveItemOrder={false}
              reorderSelectedOnOutside={true}
              disabled={fieldsLocked}
            />
          </div>
        </div>

        {/* -------- POG -------- */}
        <div>
          <label className="block text-gray-700 mb-2 font-medium">
            Permission Object Groups
          </label>

          <div className="bg-gray-50 rounded-md border border-gray-300">
            <SearchableMappingList
              fetchUrl={`${process.env.REACT_APP_ENTITLEMENTS_API}/permission-object-group`}
              selectedIds={selectedPogs}
              onSelectionChange={onPogChange}
              idField="permission_object_group_id"
              nameField="pog_name"
              allowedDomains={AMP_ENTITLEMENT_DOMAINS}
              preserveItemOrder={false}
              reorderSelectedOnOutside={true}
              disabled={fieldsLocked}
            />
          </div>
        </div>

        </div>
      </form>
    </div>
  );
};

export default UserGroupForm;